<div class="nav-container">
  <div class="nav-bar-section">
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark" >
      <a class="navbar-brand" routerLinkActive='active' [routerLink]="['/home']">AniData</a>
      <button class="navbar-toggler" type="button" data-toggle="dropdown" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" routerLinkActive='active' [routerLink]="['/home']">Home</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLinkActive='active' [routerLink]="['/animeSearch']">Search</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="refreshPage()" routerLinkActive='active' [routerLink]="['/random']">Random Anime</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLinkActive='active' [routerLink]="['/top100Anime']">Top 100 Anime</a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</div>